import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { FormSimpleAutoComplete } from '../index';
import { ListParams } from '../../types/main';
import { Organization } from '../../types/items';
import OrganizationService from '../../services/OrganizationService';

type Props = {
  fieldName?: string;
  name?: string;
  label?: string;
  disabled?: boolean;
};

const OrganizationField = ({
  fieldName = 'organization_id',
  name = '',
  disabled = false,
  label = 'Organization',
}: Props) => {
  const dispatch = useDispatch();
  const [organizations, setOrganizations] = useState<Organization[]>([]);
  const [loading, setLoading] = useState(false);

  const params: ListParams = {
    page_size: 10,
    sort_key: 'common_name',
    sort_dir: 'ASC',
  };

  const getOrganizations = useCallback(async (listParams) => {
    setLoading(true);
    const usersParams = { ...listParams };
    const fetchOrganizations = await OrganizationService.list(usersParams);
    setOrganizations(fetchOrganizations.items);
    setLoading(false);
  }, [setOrganizations, setLoading]);

  /* eslint react-hooks/exhaustive-deps: 0 */
  useEffect(() => {
    getOrganizations({ ...params, filter: { search: name } });
  }, [dispatch]);

  const searchOrganizations = useCallback((search) => {
    getOrganizations({ ...params, filter: { search } });
  }, [dispatch, getOrganizations, params]);

  const organizationsList = organizations?.map((item) => ({
    label: item.common_name,
    id: item.id,
  }));

  return (
    <FormSimpleAutoComplete
      options={organizationsList}
      label={label}
      name={fieldName}
      onSearch={searchOrganizations}
      loading={loading}
      disabled={disabled}
    />
  );
};

export default OrganizationField;
